import React from 'react';

import SidebarMenu, { type SidebarMenuItem } from './sidebar-menu';

const items: SidebarMenuItem[] = [
  { key: 'brand', to: '/brand', label: 'Brand' },
  { key: 'categories', to: '/categories', label: 'Categories' },
  { key: 'properties', to: '/properties', label: 'Properties' },
  { key: 'products', to: '/products', label: 'Products' },
  { key: 'manufacturers', to: '/manufacturers', label: 'Manufacturers' },
  {
    key: 'responsiblePersons',
    to: '/responsible-persons',
    label: 'EU responsible persons',
  },
];

function SidebarOffer(): React.ReactElement {
  return <SidebarMenu items={items} />;
}

export default SidebarOffer;
